// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/webcooking.min"], () => (__webpack_require__("./src/js/webcooking.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/webcooking.min"], () => (__webpack_require__("./src/sass/webcooking.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
